// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.model-box {
  width: 100%;
  background: #fff;
}
.model-box ion-title {
  background: #fff;
  padding: 0 3px;
  font-size: 16px;
}
.model-box .img-box {
  width: 100%;
  max-height: 120px;
  vertical-align: middle;
  display: table;
}
.model-box .img-box app-img {
  vertical-align: middle;
  display: table-cell;
  width: 100%;
}

.noStyle ion-card {
  margin: 0;
}

.title {
  min-height: 36px;
  max-height: 36px;
  font-weight: bold;
  text-align: center;
  width: 100%;
}

.relative .name-box {
  line-height: 1;
  padding: 2px 0;
}

.name-box {
  text-shadow: 0px 0px 10px #ccc;
  color: black;
}

.toolbar-row {
  display: flex;
  overflow-x: auto;
}
.toolbar-row .toolbar-item {
  flex: 0 0 auto;
  cursor: pointer;
  color: var(--main-button-backgroud);
}
.toolbar-row .toolbar-item + .toolbar-item {
  border-right: solid 1px #ccc;
}
.toolbar-row .toolbar-item:active, .toolbar-row .toolbar-item:hover {
  filter: brightness(80%);
  background: var(--button-a-background);
  color: var(--main-top-text);
}
.toolbar-row::-webkit-scrollbar {
  display: none;
}

.active {
  filter: brightness(80%);
  background: var(--button-a-background);
  color: var(--main-top-text);
}

@media screen and (min-width: 767px) {
  .model-box .img-box {
    width: 100%;
    height: 200px;
    vertical-align: middle;
    display: table;
  }
}
.fields-slider ion-slide {
  height: 40px;
  background: white;
  border-left: 1px solid #ccc;
}
.fields-slider ion-slide:hover {
  filter: brightness(95%);
  cursor: pointer;
}

.slider-container {
  position: relative;
  padding: 0 25px;
}

.prev-slide, .next-slide {
  position: absolute;
  top: calc(50% - 12px);
  z-index: 1000;
  font-size: 24px;
  color: rgba(0, 0, 0, 0.5);
  background: none;
  cursor: pointer;
}

.prev-slide {
  right: 0px;
}

.next-slide {
  left: 0px;
}`, "",{"version":3,"sources":["webpack://./src/core/components/sliders/model-slider/model-slider.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,gBAAA;AACF;AACE;EACE,gBAAA;EACA,cAAA;EACA,eAAA;AACJ;AAEE;EACE,WAAA;EAEA,iBAAA;EACA,sBAAA;EACA,cAAA;AADJ;AAIE;EACE,sBAAA;EACA,mBAAA;EACA,WAAA;AAFJ;;AAOE;EACE,SAAA;AAJJ;;AASA;EACE,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;AANF;;AASA;EACE,cAAA;EAEA,cAAA;AAPF;;AAWA;EACE,8BAAA;EAEA,YAAA;AATF;;AAYA;EACE,aAAA;EACA,gBAAA;AATF;AAWE;EAEE,cAAA;EACA,eAAA;EACA,mCAAA;AAVJ;AAaE;EACE,4BAAA;AAXJ;AAcE;EACE,uBAAA;EACA,sCAAA;EACA,2BAAA;AAZJ;AAqBA;EACE,aAAA;AAnBF;;AAsBA;EACE,uBAAA;EACA,sCAAA;EACA,2BAAA;AAnBF;;AAwDA;EAEI;IACE,WAAA;IACA,aAAA;IAEA,sBAAA;IACA,cAAA;EAvDJ;AACF;AAqEE;EACE,YAAA;EACA,iBAAA;EACA,2BAAA;AAnEJ;AAqEE;EACE,uBAAA;EACA,eAAA;AAnEJ;;AAwEA;EACE,kBAAA;EACA,eAAA;AArEF;;AAwEA;EACE,kBAAA;EACA,qBAAA;EACA,aAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;AArEF;;AAwEA;EACE,UAAA;AArEF;;AAwEA;EACE,SAAA;AArEF","sourcesContent":[".model-box {\n  width: 100%;\n  background: #fff;\n\n  ion-title {\n    background: #fff;\n    padding: 0 3px;\n    font-size: 16px;\n  }\n\n  .img-box {\n    width: 100%;\n    //height: 120px;\n    max-height: 120px;\n    vertical-align: middle;\n    display: table;\n  }\n\n  .img-box app-img {\n    vertical-align: middle;\n    display: table-cell;\n    width: 100%;\n  }\n}\n\n.noStyle {\n  ion-card {\n    margin: 0;\n  }\n}\n\n\n.title {\n  min-height: 36px;\n  max-height: 36px;\n  font-weight: bold;\n  text-align: center;\n  width: 100%;\n}\n\n.relative .name-box {\n  line-height: 1;\n  //font-size: 18px;\n  padding: 2px 0;\n  //color: var(--element-color)\n}\n\n.name-box {\n  text-shadow: 0px 0px 10px #ccc;\n  //  tmp tmp tmp tmp TODO\n  color: black;\n}\n\n.toolbar-row {\n  display: flex;\n  overflow-x: auto;\n\n  .toolbar-item {\n    //padding: 10px 24px;\n    flex: 0 0 auto;\n    cursor: pointer;\n    color: var(--main-button-backgroud);\n  }\n\n  .toolbar-item + .toolbar-item {\n    border-right: solid 1px #ccc;\n  }\n\n  .toolbar-item:active, .toolbar-item:hover {\n    filter: brightness(80%);\n    background: var(--button-a-background);\n    color: var(--main-top-text);\n  }\n\n  .toolbar-item.active {\n    //background:brightness(80%);\n  }\n\n}\n\n.toolbar-row::-webkit-scrollbar {\n  display: none;\n}\n\n.active {\n  filter: brightness(80%);\n  background: var(--button-a-background);\n  color: var(--main-top-text);\n}\n\n.scroll-box {\n  //margin: 0 4px;\n\n\n  //.arrow-segment\n  //{\n  //  ion-segment {\n  //    width: 40px;\n  //  }\n  //}\n  //\n  //.main-segment\n  //{\n  //  ion-segment {\n  //    width: fit-content;\n  //  }\n  //}\n}\n\n//background: #ccc;\n//width: 100%;\n//height: 40px;\n//margin-top: 4px;\n//line-height: 1;\n//display: table;\n\n//.name-box\n//{\n//  //vertical-align: middle;\n//  //display: table-cell;\n//}\n//}\n\n\n@media screen and (min-width: 767px) {\n  .model-box {\n    .img-box {\n      width: 100%;\n      height: 200px;\n      //max-height: 200px;\n      vertical-align: middle;\n      display: table;\n    }\n  }\n\n}\n\n\n.fields-slider{\n\n\n  //.swiper-wrapper{\n  //  gap: 1px;\n  //  background: #ccc;\n  //}\n\n  ion-slide{\n    height: 40px;\n    background: white;\n    border-left: 1px solid #ccc;\n  }\n  ion-slide:hover{\n    filter: brightness(95%);\n    cursor: pointer;\n  }\n}\n\n\n.slider-container {\n  position: relative;\n  padding: 0 25px;\n}\n\n.prev-slide, .next-slide {\n  position: absolute;\n  top: calc(50% - 12px);\n  z-index: 1000;\n  font-size: 24px;\n  color: rgba(0, 0, 0, 0.5);\n  background: none;\n  cursor: pointer;\n}\n\n.prev-slide {\n  right: 0px;\n}\n\n.next-slide {\n  left: 0px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
